import styled from 'styled-components'
import border from '../../tokens/border'
import fonts from '../../tokens/fonts'
import { ContainerAnimation as Animation } from '../table/styles'
import { composeTheme } from '../../utils/compose-theme'

export const Container = styled.div`
  position: relative;
`

export const PagesContainer = styled.div.attrs((props) => composeTheme(props))`
  background-color: ${(props) =>
    props.theme.paginationTableAlt.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: ${(props) => props.theme.paginationTableAlt.borderRadius};
  border: ${(props) => props.theme.paginationTableAlt.border};
  padding: ${(props) => props.theme.paginationTableAlt.padding};

  button.secondary {
    color: ${(props) => props.theme.paginationTableAlt.buttonColor};
    font-weight: ${(props) => props.theme.paginationTableAlt.fontWeight};
    background-color: ${(props) =>
      props.theme.paginationTableAlt.buttonBackgroundColor};
    border: ${(props) => props.theme.paginationTableAlt.buttonBorder};
    border-radius: ${(props) =>
      props.theme.paginationTableAlt.buttonBorderRadius};
    gap: 0.8rem;
    padding: ${(props) => props.theme.paginationTableAlt.buttonPadding};

    &:hover {
      background-color: ${(props) =>
        props.theme.paginationTableAlt.buttonHoverBackgroundColor};
      color: ${(props) => props.theme.paginationTableAlt.buttonHoverColor};
    }

    &:focus {
      background-color: ${(props) =>
        props.theme.paginationTableAlt.buttonFocusBackgroundColor};
      color: ${(props) => props.theme.paginationTableAlt.buttonFocusColor};
      outline: none;
      box-shadow: ${(props) =>
        props.theme.paginationTableAlt.buttonFocusShadow};
    }

    &[disabled] {
      color: ${(props) => props.theme.paginationTableAlt.buttonDisabledColor};
      background-color: ${(props) =>
        props.theme.paginationTableAlt.buttonDisabledBackgroundColor};
      border-color: #eaecf0;
      ${(props) => props.theme.paginationTableAlt.buttonDisabledBorderColor};
    }
  }
`

export const PageButtonsContainer = styled.div`
  display: flex;
  align-items: center;
`

export const PageButtonContainer = styled.div`
  .inactive {
    background-color: transparent;
    cursor: pointer;
    border: none;
    border-radius: ${border.radius.radiusNone};

    &.dots {
      cursor: initial;
    }
  }
`

export const PageButton = styled.div.attrs((props) => composeTheme(props))`
  color: ${(props) => props.theme.paginationTableAlt.buttonPageColor};
  font-weight: ${(props) => props.theme.paginationTableAlt.fontWeight};
  font-family: ${fonts.inter};
  min-width: 4rem;
  min-height: 4rem;
  background-color: ${(props) =>
    props.theme.paginationTableAlt.buttonPageBackgroundColor};
  border: ${(props) => props.theme.paginationTableAlt.buttonPageBorder};
  border-radius: ${(props) =>
    props.theme.paginationTableAlt.buttonBorderRadius};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ContainerAnimation = styled(Animation)`
  pointer-events: none;
`
